import { render, staticRenderFns } from "./SiteVersionEdit.vue?vue&type=template&id=6fef9e02&lang=pug"
import script from "./SiteVersionEdit.vue?vue&type=script&lang=js"
export * from "./SiteVersionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports